/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import TestimonialCard from './testimonial-card';

export default function TestimonialSection({ testimonials, heading, subheading }) {
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fullyVisibleIndexes, setFullyVisibleIndexes] = useState([]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollLeft, clientWidth } = container;
      const viewportCenter = scrollLeft + clientWidth / 2;
      const children = Array.from(container.children);
      if (!children.length) return;

      let closestIndex = 0;
      let minDistance = Infinity;
      const visibleIndexes = [];

      children.forEach((child, idx) => {
        const left = child.offsetLeft;
        const width = child.clientWidth;
        const right = left + width;

        if (left >= scrollLeft && right <= scrollLeft + clientWidth) {
          visibleIndexes.push(idx);
        }

        const childCenter = left + width / 2;
        const distance = Math.abs(childCenter - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = idx;
        }
      });

      setActiveIndex(closestIndex);
      setFullyVisibleIndexes(visibleIndexes);
    };

    handleScroll();
    container.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [testimonials]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (!testimonials || testimonials.length < 2) return;
    const child = container.children[1];
    if (!child) return;
    const left = child.offsetLeft;
    const width = child.clientWidth;
    const target = left - (container.clientWidth - width) / 2;
    container.scrollTo({ left: target, behavior: 'auto' });
    setActiveIndex(1);
  }, [testimonials]);

  return (
    <section className="relative w-full bg-[#d2e8ff30] py-[40px]">
      {/* <div className="flex flex-col gap-[4px] sm:gap-[5px] md:gap-[6px] items-center mb-4">
        <div className="flex gap-[10px] sm:gap-[11px] md:gap-[12px] items-center">
          <div className="w-[5px] md:w-[6px] h-7 bg-[#ff5761]" />
          <h2 className="text-[18px] sm:text-[20px] md:text-[22px]  font-medium text-[#000]">
            {heading}
          </h2>
        </div>
        <h3 className="text-[24px] sm:text-[27px] md:text-[30px]  font-semibold text-center text-[#000] leading-[36px] sm:leading-[40px] md:leading-[45px]">
          {subheading}
        </h3>
      </div> */}
      {
        (heading || subheading)
        && (
        <div className="w-full flex flex-col items-center text-center mb-3">
          {heading && <div dangerouslySetInnerHTML={{ __html: heading }} />}
          {subheading && <div dangerouslySetInnerHTML={{ __html: subheading }} />}
        </div>
        )
      }
      <div
        ref={containerRef}
        className="flex gap-[10px] md:gap-[28px] overflow-x-auto scroll-smooth snap-x snap-mandatory"
      >
        {testimonials?.map((testimonial, index) => {
          const isFullyVisible = fullyVisibleIndexes.includes(index);
          const isActive = index === activeIndex;
          const keepBright = fullyVisibleIndexes.length >= 2 ? isFullyVisible : isActive;

          return (
            <div
              key={index}
              className="flex-shrink-0 snap-center w-[352px] md:w-[49%]  md:my-7"
            >
              <TestimonialCard
                testimonial={testimonial}
                isActive={keepBright}
                isSide={!keepBright}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}

TestimonialSection.propTypes = {
  testimonials: PropTypes.array,
  heading: PropTypes.string,
  subheading: PropTypes.string,
};
